<style>
.el-dropdown-menu__item:hover {
        background-color: #f4c8201c !important;
        color: #F4C820 !important;
    }
</style>
<style scoped>
    .header-r{
        display: flex;
        align-items: center;
        height: 54px;
        margin-left: 50px;
        position: relative;
        /* right:50px; */
    }
    /* .header-r .login{
        height: 80px;
        margin-left: 50px;
        position: relative;
    } */
    .header-r .a1{
        line-height: 54px;
        color: #303133;
        font-size: 15px;
    }
    .header-r .user-op{
        position: absolute;
        top: 54px;
        right: 0;
        width: 100px;
        display: none;
        background: #fff;
        padding: 15px 0;
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);

    }
    .header-r .user-op li{
        padding: 10px 15px;
        text-align: center;
        cursor: pointer;
    }
    .header-r .user-op li:hover{
        background-color: #f6f6f6;

    }
    /* // 登录 */
    .login-box-2{
        width: 492px;
        box-sizing: border-box;
        padding: 30px;
    }
    .login-box-2 .input-block{
        margin-bottom: 20px;
    }
    .login-box-2 .btn-sub{
        display: block;
        color: #fff;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        height: 32px;
        background: #5294F9;
        border-radius: 2px;
    }
    .login-box-2 .login-foot{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-size: 13px;
    }
    .login-box-2 .login-foot a{
        color: #5294F9;
    }
    .login-box-2 .login-foot span{
        color: #909399;
    }
    
    /* // 弹窗 */
    .dialog-box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10000;
        display: none;
    }

    .dialog-box .dialog-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .dialog-box .dialog-bg .dialog {
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0px 4px 15px 0px rgba(0, 18, 41, 0.19);
    }

    .dialog-box .dialog-bg .dialog .d-head {
        height: 40px;
        background-color: #F9FAFB;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        border-radius: 2px 2px 0 0;
    }

    .dialog-box .dialog-bg .dialog .d-head .d-title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303133;
        line-height: 22px;
    }

    .dialog-box .dialog-bg .dialog .d-head .d-close {
        width: 20px;
        height: 20px;
        margin-left: 20px;
        cursor: pointer;
    }

    .dialog-box .dialog .d-con {
        /* // padding: 15px; */
        max-height: 800px;
        overflow: auto;
    }

    /* // 表单 */
    .login-box-2 .input-block{
        height: 32px;
        display: flex;
        align-items: center;
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        padding: 0 5px;
        font-size: 14px;
    }
    .login-box-2 .input-block .input-item {
        flex: 1;
        /* // padding: 0 5px; */
        outline: none;
        border: none;
    }

    .login-box-2 .input-block .icon-img {
        height: 16px;
        width: 16px;
        object-fit: contain;
        cursor: pointer;
        margin-left: 10px;
    }

    .login-box-2 .input-box {
        display: flex;
    }

    .login-box-2 .input-box .input-block {
        flex: 1;
    }

    .login-box-2 .input-box .code-btn {
        margin-left: 15px;
        width: 110px;
    }

    .login-box-2 .input-box .code-btn.is-off {
        background-color: #d4d4d4;
    }



    .login-box-2 .btn-text {
        color: #5294F9;
    }

    .login-box-2 .btn {
        display: inline-block;
        padding: 0 20px;
        box-sizing: border-box;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #5294F9;
        border-radius: 2px;
        cursor: pointer;
    }
            
</style>
<template>
    <div>
        <div class="window_nav clearfix">
            <div class="window_nav_con">
                <div class="saas-logo fl">
                    <a href="/index"><img class="saas-logo fl" src="../assets/logo.svg"></a>
                </div>
                <ul v-if="langluageType != 'en'" class="window_nav_li clearfix fl">
                    <li><el-link @click="textColor('use')" :class="url == '/use'?'on':''" :underline="false" href="use" style="font-size: 14px;">注册条款</el-link></li>
                    <li><el-link @click="textColor('privacy')" :class="url == '/privacy'?'on':''" :underline="false" href="privacy" style="font-size: 14px;">隐私条款</el-link></li>
                    <li><el-link @click="textColor('safe')" :class="url == '/safe'?'on':''" :underline="false" href="safe" style="font-size: 14px;">安全产品、服务和功能隐私声明</el-link></li>
                    <li><el-link @click="textColor('cookie')" :class="url == '/cookie'?'on':''" :underline="false" href="cookie" style="font-size: 14px;">Cookie声明</el-link></li>
                </ul>
                <ul v-else class="window_nav_li clearfix fl">
                    <li><el-link @click="textColor('use')" :class="url == '/use'?'on':''" :underline="false" href="use" style="font-size: 14px;">Registration Terms</el-link></li>
                    <li><el-link @click="textColor('privacy')" :class="url == '/privacy'?'on':''" :underline="false" href="privacy" style="font-size: 14px;">Privacy Policy</el-link></li>
                    <li><el-link @click="textColor('safe')" :class="url == '/safe'?'on':''" :underline="false" href="safe" style="font-size: 14px;">Security Products, Services and Features Privacy Statement</el-link></li>
                    <li><el-link @click="textColor('cookie')" :class="url == '/cookie'?'on':''" :underline="false" href="cookie" style="font-size: 14px;">Cookie Notice</el-link></li>
                </ul>
                <ul class="header-r fr clearfix" style="box-sizing: border-box;padding-top: 10px;">
                    <!-- <li class="en-ch"><img src="/public/images/web/images/propaganda/ch.jpg" alt=""><img src="/public/images/web/images/propaganda/en.png" alt=""></li> -->
                    <!-- <li class="denglu_btn"><a href="https://scm.exposaas.com/web/user/login">登录/注册</a></li> -->
                    <!-- <li class="denglu_btn"><a href="javascript:;">登录/注册</a></li> -->
                    <a class="j-btn-login a1" id="j-login" href="javascript:;" style="color:#F4C820;font-size: 14px;">{{langluageType == 'ch'?'登录':'Log in'}}</a>
                    <a class="j-user-down a1" id="j-user-down" href="javascript:;"></a>
                    <ul class="user-op j-user-down">
                        <li id="j-loginout" style="color:#F4C820;font-size: 14px;">{{langluageType == 'ch'?'退出登录':'out Login'}}</li>
                    </ul>
                    <el-dropdown @command="handleCommand" style=" padding-left: 10px !important;border-left: 2px solid #F4C820;margin-left: 10px !important;" trigger="click">
                        <span class="el-dropdown-link" style="color:#F4C820;">
                            {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="ch">中文</el-dropdown-item>
                            <el-dropdown-item command="en">English</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </ul>
            </div>
        </div>
        <!-- 登录 -->
        <!-- <div class="dialog-box" id="j-login-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-login">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" name="phone" type="text" placeholder="手机号">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="密码长度6-16位">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-login-sub" href="javascript:;">登录</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>没有账号？</span>
                                    <a class="btn-text j-btn-register" href="javascript:;">立即注册</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 注册 -->
        <!-- <div class="dialog-box" id="j-register-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-register">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" id="register-phone" name="phone" type="text" placeholder="手机号" autocomplete="new-password">
                                </li>
                                <li class="input-box">
                                    <div class="input-block">
                                        <input class="input-item" name="code" type="text" placeholder="验证码" autocomplete="new-password">
                                    </div>
                                    <div class="btn code-btn" id="btn-register-code" href="javascript:;">获取验证码</div>
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="密码长度6-16位" autocomplete="new-password">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="email" type="text" placeholder="邮箱" autocomplete="new-password">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-register-sub" href="javascript:;">注册</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>已有账号？</span>
                                    <a class="btn-text j-btn-login" href="javascript:;">立即登录</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 登录 中文 -->
        <div v-if="langluageType != 'en'" class="dialog-box" id="j-login-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-login">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" name="phone" type="text" placeholder="手机号">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="密码长度6-16位">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-login-sub" href="javascript:;">登录</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>没有账号？</span>
                                    <a class="btn-text j-btn-register" href="javascript:;">立即注册</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- 登录 英文 -->
        <div v-else class="dialog-box" id="j-login-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-login">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" name="phone" type="text" placeholder="Phone number">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="Pasword length 6-16 characters">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-login-sub" href="javascript:;">Log in</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>No account?</span>
                                    <a class="btn-text j-btn-register" href="javascript:;">Register Now</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- 注册 中文-->
        <div v-if="langluageType != 'en'" class="dialog-box" id="j-register-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-register">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" id="register-phone" name="phone" type="text" placeholder="手机号" autocomplete="new-password">
                                </li>
                                <li class="input-box">
                                    <div class="input-block">
                                        <input class="input-item" name="code" type="text" placeholder="验证码" autocomplete="new-password">
                                    </div>
                                    <div class="btn code-btn" id="btn-register-code" href="javascript:;">获取验证码</div>
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="密码长度6-16位" autocomplete="new-password">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="email" type="text" placeholder="邮箱" autocomplete="new-password">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-register-sub" href="javascript:;">注册</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>已有账号？</span>
                                    <a class="btn-text j-btn-login" href="javascript:;">立即登录</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- 注册 英文-->
        <div v-else class="dialog-box" id="j-register-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-register">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" id="register-phone" name="phone" type="text" placeholder="Phone number" autocomplete="new-password">
                                </li>
                                <li class="input-box">
                                    <div class="input-block">
                                        <input class="input-item" name="code" type="text" placeholder="Verification Code" autocomplete="new-password">
                                    </div>
                                    <div class="btn code-btn" id="btn-register-code" href="javascript:;">get</div>
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="Pasword length 6-16 characters" autocomplete="new-password">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="email" type="text" placeholder="Mail" autocomplete="new-password">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-register-sub" href="javascript:;">register</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>Already have an account?</span>
                                    <a class="btn-text j-btn-login" href="javascript:;">Log in</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<!-- <script src="../page/jquery.cookie.js"></script> -->
<script>

    import $ from 'jquery'
    import'../page/jquery.cookie.js'
	var _api = 'https://www.exposcm.com/home-api/api/v1'
    var regex = /^1\d{10}$/
	// 登录信息
	var user_token = $.cookie('company_user_token')
	// 设置登录状态
	// login_status()
	function login_status(){
		user_token = $.cookie('company_user_token')
		if(user_token){
			$('#j-user-down').show().text($.cookie('company_user_phone'))
			$('#j-login').hide()
		}else{
			$('#j-login').show()
			$('#j-user-down').hide()
		}
	}

	

	// 登录
	function login_sub(data){
		if(!data.phone || !data.password){
			
			return
		}
		$.ajax({
			type: "POST",
			url: _api+"/login",
			data: JSON.stringify(data),
			dataType: "json",
			success: function (res) {
				toast({msg: res.msg})
				if(res.status == 200){
					$.cookie('company_user_token', 'Bearer '+res.data.token, { expires: 1, path: '/' })
					$.cookie('company_user_phone', data.phone, { expires: 1, path: '/' })
					
					login_status()

					$('#j-login-dialog').fadeOut()
					setTimeout(() => {
						// location.reload()
                        location.href = 'https://www.exposcm.com/page/activity.html?company_user_token='+'Bearer '+res.data.token+'&company_user_phone='+data.phone
					}, 1000);
				}
			}
		});
	}

	// 注册
	function register_sub(data){
		$.ajax({
			type: "POST",
			url: _api+"/login/register",
			data: JSON.stringify(data),
			dataType: "json",
			success: function (res) {
				toast({msg: res.msg})
				if(res.status == 200){
					$('#j-register-dialog').fadeOut()
				}
			}
		});
	}

    // 点击 非classname区域
    function click_no_this_dom(classname, callback){
        $(document).bind('click',function(e){
            var e = e || window.event; //浏览器兼容性
            var elem = e.target || e.srcElement;
            while (elem) { //循环判断至跟节点，防止点击的是div子元素
                if ($(elem).hasClass(classname)) {
                    return;
                }
                elem = elem.parentNode;
            }
            callback&&callback()
        });
    }

    function _get_code(btn, phone, rul){
        var _time = 60;
        $(btn).on('click',function(){
            // var _this = $(this)
            if($(this).hasClass('is-off')){

            }else{
                var _phone = $(phone).val()
                
                if(_phone){
                    if(!regex.test(_phone)){
                        toast({ msg: '请输入正确的手机号' })
                    }else{
                        _time = 60
                        set_time()
                        get_code(_phone)
                    }
                }
            }
        })
        function set_time(){
            if( _time<= 0){
                $(btn).removeClass('is-off').html('获取验证码')
            }else{
                $(btn).addClass('is-off').html('('+_time+')')
                setTimeout(function() {
                    _time--
                    set_time()
                }, 1000)
            }
        }
        function get_code(phone){
            $.ajax({
                type: "POST",
                url: _api+rul,
                data: JSON.stringify({
                    phone: phone
                }),
                headers: {Authorization: user_token|| ''},
                dataType: "json",
                success: function (res) {
                    if(res.status == 200){
                        toast({msg: res.data.msg})
                    }else{
                        _time = 0
                        toast({msg: res.msg})
                    }
                }
            });
        }
    }

    // 获取form表单数据
    function getFormData(formId){
        var data = {};
        var results = $(formId).serializeArray();
        $.each(results,function(index,item){
            //文本表单的值不为空才处理
            if(item.value && $.trim(item.value)!=""){
                if(!data[item.name]){
                    data[item.name]=item.value;
                }else{
                    //name属性相同的表单，值以英文,拼接
                    data[item.name]=data[item.name]+','+item.value;
                }
            }
        });
        return data;
    }

    // 提示信息
    function toast(n) {
        var t = document;
        var toastId = document.getElementById('toastId');
        if(toastId){
            toastId.remove();
            // toastId.parentNode.removeChild(toastId);
        }
        
        var e = t.createElement("div")
        e.id = 'toastId';
        e.innerHTML = n.msg 
        
        t.body.appendChild(e);
        var r = setTimeout(function() {
            clearTimeout(r)
            e.remove();
            // t.body.removeChild(e)
        }, n.time || 2e3)
        
    }
    export default {
        data(){
            return {
                url:'',
                imgUrl:'eye-0.png',
                lang:'中文',
                langluageType:''
            }
        },
        watch: {
            $route: {
                handler(route) {
                this.url = this.$route.path
                },
                immediate: true,
            },
        },
        created(){
            if(!sessionStorage.getItem('langluageType')){
                sessionStorage.setItem('langluageType','ch')
                this.langluageType = 'ch'
                this.lang = '中文'
            }else{
                this.lang = sessionStorage.getItem('langluageType') == 'ch'?'中文':'English'
                this.langluageType = sessionStorage.getItem('langluageType') == 'ch'?'ch':'en'
            }
        },
        mounted(){
            let that = this
            // that.login_status()
            // 关闭弹窗
            $('.d-close').on('click',function(){
                $(this).parents('.dialog-box').fadeOut();
            })

            // 退出
            $('#j-user-down').on('click',function(){
                $('.user-op').slideDown(200);
            })
            $('#j-loginout').on('click',function(){
                $.cookie('company_user_token', null, { expires: -1, path: '/' })
                $.cookie('company_user_phone', null, { expires: -1, path: '/' })
                that.login_status()
                toast({ msg: '已退出' })
                setTimeout(function(){
                    location.reload()
                }, 1000);
                

            })
            click_no_this_dom('j-user-down', function(){
                $('.user-op').slideUp(200);
            })

            // 登录
            $('.j-btn-login').on('click',function(){
                $("#form-login")[0].reset();
                $('.dialog-box').fadeOut();
                $('#j-login-dialog').fadeIn()
            })

            // 注册
            $('.j-btn-register').on('click',function(){
                $("#form-register")[0].reset();
                $('.dialog-box').fadeOut();
                $('#j-register-dialog').fadeIn()
            })

            // 登录提交
            $('#j-login-sub').on('click',function(){
                var data = getFormData('#form-login')
                login_sub(data)
            })

            // 注册提交
            $('#j-register-sub').on('click',function(){
                var data = getFormData('#form-register')
                register_sub(data)
            })

            // 获取注册验证码
            _get_code('#btn-register-code', '#register-phone', '/login/send-msg')

            // 查看密码
            $('.j-eye').on('click',function(){
                var _this = $(this)
                _this.toggleClass('is_on')
                // _src = _this.prop('src').split('-')
                if(_this.hasClass('is_on')){
                    that.imgUrl = 'eye-1.png'
                    _this.prev('input').prop('type','text')
                }else{
                    that.imgUrl = 'eye-0.png'
                    _this.prev('input').prop('type','password')
                }
            })
        },
        methods:{
            textColor(name){
                this.url = name
            },
            handleCommand(command){
                console.log("kkk",command);
                
                this.lang = command == 'ch'?'中文':'English'
                sessionStorage.setItem('langluageType',command)
                this.langluageType = command == 'ch'?'ch':'en'
                this.$router.go(0)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/HeaderEn.vue